module.exports = __webpack_public_path__ + "static/media/bodyshock-icon-dis.98ef583b.svg";